module.exports = __webpack_public_path__ + "static/media/albums-button.028150e2.png";